export default {
    size: "30px",
    activeColor: "#2d8cf0",
    inactiveColor: "#f1f1f1"
}
